import { useEffect } from 'react'

const SITE_NAME = 'Pancita Feliz Foundation'

interface DocumentMeta {
  title: string
  description: string
  /** Route path used to build the canonical URL, e.g. "/donar". */
  path: string
}

function upsertMeta(
  attr: 'name' | 'property',
  key: string,
  content: string,
): void {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  )
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertCanonical(href: string): void {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

/**
 * Sets the document title and SEO meta tags for a page. Runs on mount and
 * whenever the provided values change, overriding any defaults from index.html.
 */
export function useDocumentMeta({
  title,
  description,
  path,
}: DocumentMeta): void {
  useEffect(() => {
    document.title = title

    upsertMeta('name', 'description', description)
    upsertMeta('name', 'robots', 'index, follow')
    upsertMeta('property', 'og:site_name', SITE_NAME)
    upsertMeta('property', 'og:title', title)
    upsertMeta('property', 'og:description', description)

    const origin =
      typeof window !== 'undefined' && window.location
        ? window.location.origin
        : ''
    upsertCanonical(`${origin}${path}`)
  }, [title, description, path])
}
